import React, { useState } from "react";
import { Box, Grid, Paper, Avatar, Typography, TextField, useTheme, Button } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { tokens } from "../../theme";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../component/authentication/auth";

const LoginScreen = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const auth = useAuth();
    const navigate = useNavigate();

    const [error, setError] = useState(false);

    return (
        <main className="content">
            <Grid>
                <Paper elevation={10} style={{ padding: 20, width: 280, margin: "50px auto", marginTop: "100px", backgroundColor: colors.primary[999], borderRadius:10 }}>
                    <Grid align="center">
                        <Avatar style={{ backgroundColor: colors.orange[500], width: "100px", height: "100px" }}><PersonOutlinedIcon style={{ width: "70px", height: "70px" }} /></Avatar>
                        <Typography variant="h2" mt="10px">Sign In</Typography>
                        {
                            error && <Typography marginTop="10px" color="red">wrong username or password!</Typography>
                        }
                    </Grid>
                    <Formik
                        initialValues={{
                            username: "",
                            password: ""
                        }}
                        validationSchema={
                            Yup.object({
                                username: Yup.string().required("required"),
                                password: Yup.string().required("required"),
                            })
                        }
                        onSubmit={(values) => {
                            if (values.username === "AdminGME" && values.password === "Admin@GME") {
                                auth.login("Admin");
                                navigate("/portal");
                            }
                            else if (values.username === "TutorGME" && values.password === "Tutor123456") {
                                auth.login("Tutor");
                                navigate("/portal");
                            }
                            else if (values.username === "IT_GME" && values.password === "Qwerty123456") {
                                auth.login("IT");
                                navigate("/portal");
                            }
                            else {
                                setError(true);
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box display="grid" gap="10px" mt="10px">
                                    <TextField
                                        fullWidth
                                        type="text"
                                        label="Username"
                                        value={values.username}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="username"
                                        error={!!touched.username && !!errors.username}
                                        helperText={touched.username && errors.username}
                                    />
                                    <TextField
                                        fullWidth
                                        type="password"
                                        label="Password"
                                        value={values.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="password"
                                        error={!!touched.password && !!errors.password}
                                        helperText={touched.password && errors.password}
                                    />

                                </Box>
                                <Button
                                    type="submit"
                                    color='secondary'
                                    variant="contained"
                                    fullWidth
                                    style={{ marginTop: "20px", marginBottom: "20px" }}
                                >
                                    Sign In
                                </Button>
                            </form>
                        )}
                    </Formik>
                </Paper>
            </Grid>
        </main>
    )
}

export default LoginScreen;